<label class="tool-label" title="{{ config.description }}">
  {{ config.label }}
</label>
<button class="btn-tool btn --secondary --inline u-margin-top--xxs">{{#context}}Change Assessment{{else}}Choose Assessment{{/context}}</button>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
